"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHeadline = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const StyledHeadline = _styledComponents.default.h1(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  text-align: center;\n  color: ", ";\n  font-size: ", ";\n  margin: ", ";\n  @media (max-width: ", ") {\n    font-size: ", ";\n  }\n  ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.color.font.primary;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.font.size.lg;
}, _ref3 => {
  let {
    margin
  } = _ref3;
  return margin || '0px';
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.breakpoint.md;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.font.size.md;
}, _ref6 => {
  var _theme$components, _theme$components$hea;

  let {
    theme
  } = _ref6;
  return theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : (_theme$components$hea = _theme$components.headline) === null || _theme$components$hea === void 0 ? void 0 : _theme$components$hea.headline;
});

exports.StyledHeadline = StyledHeadline;